import { useModel } from 'umi';
import React, { useEffect } from 'react';
import { loginCas } from '@/utils/index';

type Props = {};

const NeedLogin: React.FC<Props> = () => {
  const { initialState } = useModel('@@initialState');
  useEffect(() => {
    if (!initialState) {
      loginCas({
        env: process.env.UMI_ENV === 'product' ? 'prod' : 'test',
      });
    }
  }, []);

  return null;
};

export default NeedLogin;
